export const colors = [
    '#FF9F00',
    '#0C1217',
    '#633025',
    '#414141',
    '#858585',
    '#BBBDBD',
    '#26BC7D',
    '#FED33C',
]